/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.

This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.

License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.

This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.

For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/
import { Card } from "../Card";
import { Chip } from "../Chip";
import { Divider } from "../Divider";
import { Grid } from "../Grid";
import { ReadOnlyField } from "../ReadonlyField";
import "./SectionWizardView.css";
import { ISectionWizardViewProps, ISubsection } from "./types";

const WizardSubsection = ({ options }: { options: ISubsection }) => {
  const { statusSection, section, footer: Footer, isFullScreen } = options;
  const responsiveColumn = isFullScreen
    ? { xs: 6, sm: 6, md: 12, lg: 12, xl: 12 }
    : 12;

  return (
    <div className="wizard-subsection-container">
      <Grid
        container
        direction="row"
        justifySelf={"baseline"}
        alignItems={"baseline"}
      >
        <div className="chip-title">{statusSection?.title}</div>
        {statusSection?.options.map((data) => (
          <div className="chip-container-style" key={data.title}>
            <Chip title={data.title} variant={data.variant} />
          </div>
        ))}
      </Grid>
      <Grid
        container
        spacing={1}
        padding={2}
        paddingLeft={0}
        columns={responsiveColumn}
      >
        {section?.map((field) => {
          return (
            <Grid
              key={field.options.fieldName}
              size={isFullScreen ? { xs: 3, sm: 3, md: 4, lg: 3, xl: 3 } : 6}
            >
              <ReadOnlyField
                fieldName={field.options.fieldName}
                fieldValue={field.options.fieldValue}
              />
            </Grid>
          );
        })}
      </Grid>
      {Footer && <Footer />}
      <Divider className="wizard-subsection-container-divider" />
    </div>
  );
};

const SectionWizardView = ({
  header,
  subsections,
}: ISectionWizardViewProps) => {
  return (
    <Card>
      <div className="section-wizard-view-container">
        <h2>{header?.title}</h2>
        <div className="section-container">
          {subsections?.map((sectionData, idx) => (
            <WizardSubsection key={idx} options={sectionData} />
          ))}
        </div>
      </div>
    </Card>
  );
};

SectionWizardView.defaultProps = {
  isFullScreen: true,
};

export default SectionWizardView;
